// extracted by mini-css-extract-plugin
export default {"tooltip":"Node_tooltip__J+pF-","tooltiptext":"Node_tooltiptext__eEtnG"};